module.exports = __webpack_public_path__ + "media/images/writer/community/sp-headline-about-maker@3x-28e6ace0e55cee1036bdb9f7bd04deaa.png";